import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import UserService from './UserService';

// Создание axios instance с базовым URL
export const clientCC: AxiosInstance = axios.create({
  baseURL: import.meta.env.REACT_APP_API_URL || '',
  timeout: 12600000, // 6 часов
});

/**
 * Настройка interceptors для автоматического добавления токена аутентификации
 */
const configure = (): void => {
  clientCC.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      if (UserService.isLoggedIn()) {
        await UserService.updateToken(() => {
          const token = UserService.getToken();
          if (token && config.headers) {
            config.headers.Authorization = `Bearer ${token}`;
          }
        });
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Добавляем interceptor для обработки ошибок ответа
  clientCC.interceptors.response.use(
    (response) => response,
    (error) => {
      // Логируем ошибку для отладки
      console.error('API Error:', error.response?.data || error.message);
      return Promise.reject(error);
    }
  );
};

const HttpService = {
  configure,
};

export default HttpService;
